import lazyWithRetry from '@shared/lib/lazyWithRetry';
import { Navigate } from 'react-router-dom';

import AppProvidersWrapper from '@components/AppProvidersWrapper/AppProvidersWrapper';
import Loadable from '@components/Loadable/Loadable';
import { ProtectedRoute } from '@providers/ProtectedRoute/ui/ProtectedRoute';
import MainLayout from '@layout/MainLayout';
import RouteErrorPage from '@components/RouteErrorPage';
import SuperAdminChildRoutes from '@routes/app/super-admin';
import DocumentPromptPreviewChildRoutes from '@routes/app/super-admin/DocumentPromptPreviewChildRoutes';
import MultiDocumentAgentRoutes from '@routes/app/super-admin/MultiDocumentAgentRoutes';
import DocumentTemplateChildRoutes from '@routes/app/super-admin/DocumentTemplateChildRoutes';
import SettingsChildRoutes from '@routes/app/settings';
import MyDocumentsChildRoutes from '@routes/app/my-documents';
import GPTChildRoutes from '@routes/app/gpt';
import CaseChildRoutes from '@routes/app/cases';

const DashboardHomePage = Loadable(
  lazyWithRetry(() => import('@pages/DashboardHomePage/DashboardHomePage'))
);
const NotFound = Loadable(
  lazyWithRetry(() => import('@pages/NotFound/NotFound'))
);

const AppRoutes = {
  path: '/',
  element: (
    <AppProvidersWrapper>
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    </AppProvidersWrapper>
  ),
  // A crash in the layout itself (sidebar, header) lands here.
  errorElement: <RouteErrorPage />,
  children: [
    {
      // A crash inside a page lands here and keeps the sidebar, so the user
      // can navigate away (ZLAYT-1406).
      errorElement: <RouteErrorPage />,
      children: [
        { index: true, element: <Navigate to="/home" /> },
        {
          path: 'home',
          element: <DashboardHomePage />,
        },
        MyDocumentsChildRoutes,
        CaseChildRoutes,
        SettingsChildRoutes,
        SuperAdminChildRoutes,
        DocumentPromptPreviewChildRoutes,
        MultiDocumentAgentRoutes,
        DocumentTemplateChildRoutes,
        GPTChildRoutes,
        { path: '*', element: <NotFound /> },
      ],
    },
  ],
};

export default AppRoutes;
